import {
	ApplicationConfig,
	provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { AUTH_API_BASE_URL, AUTH_SUPABASE_CLIENT } from '@pressteaze/auth';
import { createBrowserSupabaseClient } from '@pressteaze/data-access';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';
import { OperatorAccessTokenProvider } from './operator-access-token.provider';

export const appConfig: ApplicationConfig = {
	providers: [
		provideBrowserGlobalErrorListeners(),
		provideRouter(appRoutes),
		provideHttpClient(),
		{
			provide: AUTH_API_BASE_URL,
			useValue: `${environment.supabaseUrl}/functions/v1`,
		},
		{
			provide: AUTH_SUPABASE_CLIENT,
			useFactory: (accessTokenProvider: OperatorAccessTokenProvider) =>
				createBrowserSupabaseClient(
					{
						url: environment.supabaseUrl,
						publishableKey: environment.supabasePublishableKey,
					},
					{
						accessToken: () => accessTokenProvider.getAccessToken(),
					},
				),
			deps: [OperatorAccessTokenProvider],
		},
	],
};
